import Container from 'react-bootstrap/Container';
import { Collapse, Popover, Toast, Tooltip, Alert, Modal, Dropdown, Card, Table, Button,Form } from "react-bootstrap";

import { FaFilePdf, FaBars, FaCommentDots, FaEdit, FaTrashAlt } from 'react-icons/fa';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import React, {useMemo, useState ,useEffect, useReducer, fetchData} from 'react';
import MaterialReactTable from 'material-react-table';
import useBackend, {Loading, CallAPI, SpinnerX, Check} from '../../services/useBackend';


export default function Productgroups(props) {
    const [object2Edit,  setObject2Edit]       = useState({Name:"", ProductsCnt:0, Active:false});
    const [editShow, setEditShow]      = useState(false);
    const [addShow, setAddShow]      = useState(false);

    var typingTimeout = null;

    const { loading, data, Refresh } = useBackend('/api/admin/register');

    const columns = useMemo(() => [
         { size: 40, accessorKey: 'Name',  header: 'Namn' },
         { size: 40, accessorKey: 'ProductsCnt',  header: 'Antal varor' },
         { size: 20, accessorKey:'Default', header: 'Standard', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
         },
         { size: 20, accessorKey:'Active', header: 'Aktiv', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
         },
      ]
    );

   function handleChange(event){
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(handleSave, 475);
   }

   async function handleSave(){
      const EventForm                 = document.getElementById('productGroupForm');
      const formData                  = new FormData(EventForm);
      const formDataObj               = Object.fromEntries(formData.entries());

      formDataObj.Active       = formData.has('Active') ? true : false;
      formDataObj.Default       = formData.has('Default') ? true : false;
      let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/productgroups/'+object2Edit.Guid, 'PATCH', JSON.stringify(formDataObj));      
      Refresh();		
   }   

   const editProductGroupHandler = (event, rowData)  =>  {
      setObject2Edit(rowData.original);
      setEditShow(!editShow);
   }

   const addHandler = async ()  =>  {
      const EventForm                 = document.getElementById('productGroupAddForm');
      const formData                  = new FormData(EventForm);
      const formDataObj               = Object.fromEntries(formData.entries());
      let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/productgroups', 'POST', JSON.stringify(formDataObj));      

      setTimeout(() => {
         setAddShow(!addShow);
      }, 2000);
      
      Refresh();
   }      
 
   if (!loading) {
    return (
      <ContentWrapper> 
         <Modal show={editShow} onHide={()=>setEditShow(!editShow)}>
            <Modal.Header closeButton>
               <Modal.Title>Editera produktgrupp</Modal.Title>
            </Modal.Header>

            <Modal.Body>
               <Form id="productGroupForm">
                  <Form.Group className="mb-3" >
                     <Form.Label>Namn</Form.Label>
                     <Form.Control type="text" name="Name" size='lg' onChange={handleChange} defaultValue={object2Edit.Name}/>
                  </Form.Group>

                  <Form.Group className="mb-3" >
                     <Form.Label>Antal varor</Form.Label>
                     <Form.Control type="text" name="ProductsCnt" disabled size='lg' defaultValue={object2Edit.ProductsCnt}/>
                  </Form.Group>      

                  <Form.Group className="mb-3" >
                     <Form.Check 
                        type="switch"
                        name="Default"
                        id="Default"
                        label={'Standard'}
                        defaultChecked={object2Edit.Default}
                        value={object2Edit.Default}
                        onChange={handleChange}
                     />
                  </Form.Group>                               

                  <Form.Group className="mb-3" >
                     <Form.Check 
                        type="switch"
                        name="Active"
                        id="Active"
                        label={'Aktiv'}
                        defaultChecked={object2Edit.Active}
                        value={object2Edit.Active}
                        onChange={handleChange}
                     />
                  </Form.Group>           
               </Form>
            </Modal.Body>
            <Modal.Footer>
               {/* <Button variant="warning" onClick={()=>setEditShow(!editShow)}>Avbryt</Button> */}
            </Modal.Footer>
         </Modal>

         <Modal show={addShow} onHide={()=>setAddShow(!addShow)}>
            <Modal.Header closeButton>
               <Modal.Title>Lägg till produktgrupp</Modal.Title>
            </Modal.Header>

            <Modal.Body>
               <Form id="productGroupAddForm">
                  <Form.Group className="mb-3" >
                     <Form.Label>Namn</Form.Label>
                     <Form.Control type="text" name="name" size='lg' defaultValue={""}/>
                  </Form.Group>               
               </Form>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="primary" onClick={()=>addHandler()}>Spara</Button>
            </Modal.Footer>
         </Modal>          

         <Container>
            <Sida>
               <MaterialReactTable 
                     columns={columns} data={data.productGroups} initialState={props.initialState}
                     muiTablePaginationProps={props.muiTablePaginationProps} renderTopToolbarCustomActions={() => (<Rubrik>{props.Rubrik}</Rubrik>)}                
                     renderTopToolbarCustomActions={() => (<Rubrik>Varugrupper</Rubrik>)}
                     muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                     muiTableBodyRowProps={({ row }) => ({ onClick: (event) => { editProductGroupHandler(event, row); }, sx: { cursor: 'pointer' } })} 
                     
               />
{/* onPaginationChange={setPagination} state={state} */}
<Button className="QmeButton" variant="primary" type="submit" onClick={()=>setAddShow(!addShow)}>Ny varugrupp</Button> 
            </Sida>
            
         </Container>
       </ContentWrapper>
    );
   }
 }
